var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddItem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon-Color",
    className: "cls-1",
    d: "M20.73,0A3.28,3.28,0,0,1,24,3.27h0V20.73A3.28,3.28,0,0,1,20.73,24H3.27A3.28,3.28,0,0,1,0,20.73H0V3.27A3.28,3.28,0,0,1,3.27,0H20.73Zm0,2.18H3.27A1.09,1.09,0,0,0,2.18,3.27h0V20.73a1.09,1.09,0,0,0,1.09,1.09H20.73a1.09,1.09,0,0,0,1.09-1.09h0V3.27a1.09,1.09,0,0,0-1.09-1.09ZM12,6.06a1.08,1.08,0,0,1,1.08,1v3.89h3.76A1.09,1.09,0,0,1,17,13.08H13.09v3.76a1.09,1.09,0,0,1-2.17.13V13.09H7.15A1.09,1.09,0,0,1,7,10.92h3.89V7.15A1.09,1.09,0,0,1,12,6.06Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddItem);
export default __webpack_public_path__ + "static/media/add-item.bf1a28f82512df7db13c53b2425cd34a.svg";
export { ForwardRef as ReactComponent };